import { getGlobalProperty } from "@faire/web/common/globals/getGlobalProperty";

export const getCookieConsentKey = (): string | undefined =>
  getGlobalProperty("cookieConsentKey");
